import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistDataLeakContract } from "../../Persist/DataLeakContractPersister";
import { stageMetaDataCase } from "../../Stages/StagesCase";
import * as caseStages from "../../Stages/StagesCase";
import * as caseStatus from "../../LeadStatus/StatusCase";
import dataLeakTransformations from "../FormTransformations/dataLeakTransformations";
import { stageFormDefinition as stageFormDefinitionDataLeakContract } from "../FormDefinitions/dataLeakContract/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionDataLeakContract } from "../FormDefinitions/dataLeakContract/fullFormDefinition";
import { contractCaseDetailsSpecialActions } from "../CaseDetailsSpecialActions/contractCaseDetailsSpecialActions";
import { getDataLeakContractBadges } from "../Badges/getDataLeakContractBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { DataLeakContract } from "../../../types/Products/ContractLaw/DataLeakContract";
import { getProductData } from "./productService";

export const dataLeakContract: ProductData<DataLeakContract> = {
  urlPart: "datenweitergabe",
  lbUrlPart: "datenweitergabe",
  label: translate("dataLeakContract.label"),
  generalLabel: "Datenweitergabe",
  apiUri: "data_leak_contracts",
  persist: persistDataLeakContract,
  stages: stageMetaDataCase,
  stageConstants: caseStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_DATA_COMPLETED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\ContractLaw\\DataLeakContract\\DataLeakContract",
  formTransformations: dataLeakTransformations,
  formDefinition: ({ product, currentUser }) => stageFormDefinitionDataLeakContract(product, currentUser),
  formDefinitionExternals: ({ product }) => stageFormDefinitionDataLeakContract(product)[product.stage],
  fullFormDefinition: ({ product }) => fullFormDefinitionDataLeakContract(product),
  caseDetailsSpecialActions: ({ product }) => contractCaseDetailsSpecialActions(product),
  productCategory: "contractLaw",
  productSpecificBadges: ({ product }) => getDataLeakContractBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.dataLeakContract,
};
